import React from 'react';
import { Link } from 'react-router-dom';
import './Support.css';

function Support() {
  return (
    <div className="main-content">
      <h1>💬 Support & Troubleshooting</h1>
      <hr className="divider" />

      <p>
        If you encounter any issues or have questions, please use the resources below. This is an internal tool, and support is provided on a best-effort basis.
      </p>

      <hr className="divider" />

      <div className="support-grid">
        <div className="support-section">
          <h2>1. Self-Help Resources</h2>

          <h3>Check the Documentation First</h3>
          <p>
            Many common questions about packaging, deploying, and troubleshooting are answered in the main app documentation.
          </p>
          <Link to="/documentation" className="button-primary">
            📖 Read the App Documentation
          </Link>

          <h3 style={{ marginTop: '2rem' }}>Common Troubleshooting Steps</h3>
          <div className="troubleshooting-box">
            <div className="troubleshooting-item">
              <h4>Problem: Why is the 'Deploy Dashboard' button disabled?</h4>
              <p><strong>Solution:</strong> The deploy button will only activate when all conditions are met:</p>
              <ul>
                <li>A <code>_package.json</code> file has been successfully uploaded.</li>
                <li>You have fully configured both the Workspace and Semantic Model options.</li>
                <li>If using an existing semantic model, all missing dependencies must be mapped.</li>
              </ul>
            </div>

            <div className="troubleshooting-item">
              <h4>Problem: I received an error during deployment. What should I do?</h4>
              <p><strong>Solution:</strong> Read the error message carefully. Common causes include:</p>
              <ul>
                <li><strong>Permissions:</strong> You may not have the necessary Salesforce permissions to create/edit Tableau assets in the target org.</li>
                <li><strong>Data Kit Not Deployed:</strong> The most common error is forgetting to deploy the Data Kit with the required DMOs to the target org first.</li>
                <li><strong>Invalid Mapping:</strong> A field you mapped may not be a compatible type with the required field.</li>
              </ul>
            </div>

            <div className="troubleshooting-item">
              <h4>Problem: I can't log in or the app seems stuck.</h4>
              <p><strong>Solution:</strong> Try clearing your browser cache and cookies for this site, then attempt to log in again.</p>
            </div>
          </div>
        </div>

        <div className="support-section">
          <h2>2. Contact Support</h2>
          <p>If you've checked the resources and are still having trouble, please reach out for help.</p>

          <h3>Contact Information</h3>
          <div className="contact-box">
            <strong>Primary Contact (Slack):</strong>
            <br />
            <a 
              href="https://salesforce.enterprise.slack.com/archives/D02DWK4HE64"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              @alaviron
            </a>
          </div>

          <h3>How to Report an Issue</h3>
          <div className="alert-info">
            💡 To help us resolve your issue quickly, please include the following information in your message:
            <ul style={{ marginTop: '0.75rem', paddingLeft: '1.5rem' }}>
              <li>A clear description of the problem.</li>
              <li>The steps you took to produce the error.</li>
              <li>The <strong>Org ID</strong> you were using (visible in the sidebar).</li>
              <li>Any error messages that appeared on the screen.</li>
              <li>A <strong>screenshot</strong> of the issue, if possible.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;

